import React from 'react';

const iconBaseProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  'aria-hidden': true,
  focusable: false,
};

function IconWrap({ children, size = 16, className = 'notification-icon-svg' }) {
  return (
    <svg {...iconBaseProps} width={size} height={size} className={className}>
      <g
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {children}
      </g>
    </svg>
  );
}

/** Nowe zgłoszenie — karta + sylwetka + strzałka wejścia */
export function NotificationApplicationReceivedIcon(props) {
  return (
    <IconWrap {...props}>
      <rect x="4" y="4.5" width="16" height="15" rx="2.8" />
      <circle cx="12" cy="10.2" r="2.2" />
      <path d="M7.5 17.2c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5" />
      <path d="M16.2 6.3 19.2 3.3M19.2 3.3v2.8M19.2 3.3h-2.8" />
    </IconWrap>
  );
}

/** Akceptacja — okrąg + mocny fistaszek + iskry */
export function NotificationAcceptedIcon(props) {
  return (
    <IconWrap {...props}>
      <circle cx="12" cy="12" r="8.2" />
      <path d="m8.2 12.2 2.4 2.4 5.2-5.4" />
      <path d="M17.2 6.8l1.2 1.2M5.6 6.8 4.4 8M18.4 4.6l-.9.9" />
    </IconWrap>
  );
}

/** Odrzucenie — sześciokąt z X */
export function NotificationRejectedIcon(props) {
  return (
    <IconWrap {...props}>
      <path d="M12 3.4 18.2 7v9.6L12 20.6 5.8 16.6V7L12 3.4Z" />
      <path d="M9.2 9.2l5.6 5.6M14.8 9.2l-5.6 5.6" />
    </IconWrap>
  );
}

/** Kalendarz — czytelna siatka + spinacze */
export function NotificationCalendarIcon(props) {
  return (
    <IconWrap {...props}>
      <rect x="4.5" y="5.5" width="15" height="14" rx="2.4" />
      <path d="M8.5 4v4M15.5 4v4M4.5 10h15" />
      <path d="M8 13.5h2.5M13.2 13.5h2.5M8 16.8h2.5M13.2 16.8h2.5" />
    </IconWrap>
  );
}

/** Utworzono wydarzenie — kalendarz + wyraźny plus */
export function NotificationCalendarPlusIcon(props) {
  return (
    <IconWrap {...props}>
      <rect x="4.5" y="5.5" width="15" height="14" rx="2.4" />
      <path d="M8.5 4v4M15.5 4v4M4.5 10h15" />
      <path d="M12 12.8v4.4M9.8 15h4.4" />
    </IconWrap>
  );
}

/** Wkrótce — zegar z łukiem „countdown” */
export function NotificationClockIcon(props) {
  return (
    <IconWrap {...props}>
      <circle cx="12" cy="12" r="8.2" />
      <path d="M12 8.2v4l3.2 1.8" />
      <path d="M12 3.6v1.4M12 19v1.4M3.6 12h1.4M19 12h1.4" />
    </IconWrap>
  );
}

/** Start wydarzenia — pierścień + play („trwa / ruszyło”) */
export function NotificationRocketIcon(props) {
  return (
    <IconWrap {...props}>
      <circle cx="12" cy="12" r="7.35" />
      <path
        fill="currentColor"
        stroke="none"
        d="M10.25 8.85v6.3L16.45 12l-6.2-3.15z"
      />
    </IconWrap>
  );
}

/** Anulowanie / alert — trójkąt + wykrzyknik */
export function NotificationWarningIcon(props) {
  return (
    <IconWrap {...props}>
      <path d="M12 4.2 19.2 18.5H4.8L12 4.2Z" />
      <path d="M12 9.5V14M12 16.2h.01" />
    </IconWrap>
  );
}

/** Wyrzucony — okrągły znak zakazu */
export function NotificationBanIcon(props) {
  return (
    <IconWrap {...props}>
      <circle cx="12" cy="12" r="8.2" />
      <path d="M7.4 7.4 16.6 16.6" />
    </IconWrap>
  );
}

/** Zaproszenie do znajomych — osoba + „dodaj” (plus w kółku) */
export function NotificationHandshakeIcon(props) {
  return (
    <IconWrap {...props}>
      <circle cx="8.2" cy="9.2" r="2.5" />
      <path d="M3.8 18.5v-.4a4.4 4.4 0 0 1 8.8 0v.4" />
      <circle cx="17.2" cy="9" r="3.1" />
      <path d="M17.2 6.3v5.4M14.5 9h5.4" />
    </IconWrap>
  );
}

/** Zaproszenie na event — bilet / koperta z pinezką */
export function NotificationInvitationIcon(props) {
  return (
    <IconWrap {...props}>
      <path d="M5 8.5h14v10a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 18.5v-10Z" />
      <path d="M5 8.5 12 13l7-4.5" />
      <path d="M12 4.5v2.5M10.5 5.75h3" />
    </IconWrap>
  );
}

/** Znajomy dołączył do wydarzenia — sylwetka + kalendarz (wyróżniony dzień) */
export function NotificationUsersIcon(props) {
  return (
    <IconWrap {...props}>
      <circle cx="7.4" cy="8.6" r="2.35" />
      <path d="M3.2 18.2v-.35a4.2 4.2 0 0 1 8.4 0v.35" />
      <rect x="11.2" y="5" width="10.2" height="12.8" rx="2" />
      <path d="M13.6 3.6v3.2M19.2 3.6v3.2M11.2 9.4h10.2" />
      <rect x="14.8" y="11.6" width="2.8" height="2.35" rx="0.45" />
    </IconWrap>
  );
}

/** Odznaka odblokowana — puchar z gwiazdką */
export function NotificationTrophyIcon(props) {
  return (
    <IconWrap {...props}>
      <path d="M8 6.5h8v2.4a4 4 0 0 1-8 0V6.5Z" />
      <path d="M8 8.2H6.5a2 2 0 0 0 0 4H8M16 8.2h1.5a2 2 0 0 1 0 4H16" />
      <path d="M12 11.2V14.5" />
      <path d="M9.2 19h5.6l-1-4.5h-3.6L9.2 19Z" />
      <path d="M12 4.2 12.8 6M11.2 4.2 11.4 6" />
    </IconWrap>
  );
}

/** System / fallback — dzwon z falą */
export function NotificationBellIcon(props) {
  return (
    <IconWrap {...props}>
      <path d="M12 3.8a5.2 5.2 0 0 0-5.2 5.2c0 3-1.4 4.2-1.4 4.2h13.2s-1.4-1.2-1.4-4.2A5.2 5.2 0 0 0 12 3.8Z" />
      <path d="M9.8 17.8a2.2 2.2 0 0 0 4.4 0" />
      <path d="M12 2.5v1.3M5.5 7.5c-.4 1-.6 2-.6 3" />
    </IconWrap>
  );
}

export const notificationIconComponentMap = {
  accepted: NotificationAcceptedIcon,
  'application-received': NotificationApplicationReceivedIcon,
  ban: NotificationBanIcon,
  bell: NotificationBellIcon,
  calendar: NotificationCalendarIcon,
  'calendar-plus': NotificationCalendarPlusIcon,
  clock: NotificationClockIcon,
  handshake: NotificationHandshakeIcon,
  invitation: NotificationInvitationIcon,
  rejected: NotificationRejectedIcon,
  rocket: NotificationRocketIcon,
  trophy: NotificationTrophyIcon,
  users: NotificationUsersIcon,
  warning: NotificationWarningIcon,
};

export function NotificationIconGlyph({ icon, ...props }) {
  const IconComponent = notificationIconComponentMap[icon] || NotificationBellIcon;
  return <IconComponent {...props} />;
}
